import { render, staticRenderFns } from "./SmallMap.vue?vue&type=template&id=492d655d&scoped=true"
import script from "./SmallMap.vue?vue&type=script&lang=js"
export * from "./SmallMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d655d",
  null
  
)

export default component.exports